import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import PasswordInput from '../../components/ui/PasswordInput';

export default function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const login = useStore(s => s.login);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email || !password) { setError(t('auth.fieldRequired')); return; }
    const res = login(email, password);
    if (res.ok) navigate('/gateway');
    else setError(t(res.error || 'common.error'));
  };

  return (
    <div className="min-h-dvh bg-ivory flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-sm space-y-8">
        <div className="text-center space-y-2">
          <h1 className="font-serif text-3xl tracking-widest-xl">AH</h1>
          <p className="text-[11px] tracking-widest-2xl uppercase text-charcoal/40 font-sans">{t('auth.loginTitle')}</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder={t('auth.email')}
              className="w-full border-b border-charcoal/15 py-2.5 text-sm font-sans bg-transparent focus:border-charcoal/40 transition-colors placeholder:text-charcoal/25" />
          </div>
          <PasswordInput value={password} onChange={setPassword} placeholder={t('auth.password')} />
          {error && <p className="text-xs text-burgundy font-sans">{error}</p>}
          <button type="submit" className="w-full py-3 bg-charcoal text-ivory text-[11px] tracking-widest-xl uppercase font-sans hover:bg-charcoal/90 transition-colors">
            {t('auth.enterHouse')}
          </button>
        </form>

        <div className="text-center space-y-3">
          <Link to="/register" className="text-[11px] tracking-widest uppercase font-sans text-charcoal/40 hover:text-charcoal transition-colors">
            {t('auth.noAccount')} {t('auth.requestEntry')}
          </Link>
          <Link to="/restore-access" className="block text-[11px] tracking-widest uppercase font-sans text-charcoal/25 hover:text-charcoal/50 transition-colors mt-2">
            {t('auth.restoreAccess')}
          </Link>
        </div>

        <div className="flex justify-center pt-4">
          <LanguageSwitcher />
        </div>
      </div>
    </div>
  );
}
